import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Constants} from '../../utils/constants';
import {Login} from '../../model/login.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigService} from '../../services/webFeeder/config.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerAuthService {

  constructor(
    private httpService: HttpClient,
    private configService: ConfigService
  ) {
  }

  getBrokerAccount() {
    return window.sessionStorage.getItem(Constants.COOKIE_HB_BROKER_ACCOUNT);
  }

  brokerServiceLogin(username: string, password: string, broker: string) {
    let url: string = '/services/Authenticate/LoginHomeBroker';
    if (!!this.getBrokerAccount()) {
      url = '/services/AuthFast/LoginSignIn';
    }
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + environment.BROKER
    };
    const params: string = JSON.stringify(credential);
    const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this.httpService
      .post(this.configService.getApiWebFeederRest() + url, params, {headers});
  }

  loginBroker(username: string, password: string, profile?: any) {
    const credential: Login = {
      username: username,
      password: password,
      softwareVersion: environment.version,
      softwareName: Constants.DEFAULT_SOFTWARE_NAME + '_' + profile
    };
    const user = {username: credential.username, firstName: '', lastName: ''};
    this.configService.setHbCurrentUser(user);
    return this.httpService.post(this.configService.getApiWebFeederRest() + '/services/AuthFast/LoginO', credential, Constants.httpOptions);
  }
}
